import { useMemo } from 'react';
import { generate } from 'lean-qr';
import { toSvgDataURL, toSvgSource } from 'lean-qr/extras/svg';

import { cx } from '@libs/classnames';
import { downloadBlobAsFile } from '@libs/file';
import { useClipboard } from '@libs/hooks/useClipboard';
import useLockBodyScroll from '@libs/hooks/useLockBodyScroll';

import { Button } from '@features/game/ui/PopupControls';
import stylesControls from '@features/game/ui/PopupControls/PopupControls.module.css';

import styles from './HostModal.module.css';

export function HostModal({
  className,
  isMobile,
  link,
}: {
  className?: string;
  isMobile: boolean;
  link: string;
}) {
  useLockBodyScroll();

  const code = useMemo(() => generate(link), [link]);
  const dataUrl = useMemo(
    () =>
      toSvgDataURL(code, {
        on: '#fff',
        width: 160,
        height: 160,
        scale: 10,
        pad: 0,
      }),
    [code],
  );

  const onDownload = () => {
    const src = toSvgSource(code, {
      scale: 20,
      on: '#000',
      off: '#fff',
    });
    const blob = new Blob([src], {
      type: 'image/svg+xml',
    });

    downloadBlobAsFile(`invite-${Date.now()}.svg`, blob);
  };

  const canShare = Boolean(isMobile && navigator.share);
  const onShare = () => {
    if (navigator.share) {
      navigator.share({
        title: 'ChessOpen Play: приглашение на игру',
        text: 'Перейдите по ссылке, чтобы принять приглашение',
        url: link,
      });
    }
  };

  const { copy, copyState } = useClipboard();
  const onCopy = () => copy(link);

  return (
    <section
      className={cx(className, stylesControls.container, styles.host_modal, {
        [styles.mobile]: isMobile,
        [styles.desktop]: !isMobile,
      })}
    >
      <h1>Ожидание соперника</h1>
      <div className={styles.cols}>
        <article>
          {isMobile && <img className={styles.img} src={dataUrl} />}
          <p className={styles.subhead}>
            Отправьте ссылку для присоединения к игре{isMobile ? ':' : ''}
          </p>
          <p className={styles.link}>
            <a href={link} onClick={(e) => e.preventDefault()}>
              {link}
            </a>
          </p>
          <div className={styles.btn_group}>
            <Button className={styles.btn} disabled={copyState === 'copying'} onClick={onCopy}>
              {(copyState === 'idle' || copyState === 'copying') && 'Скопировать'}
              {copyState === 'copied' && 'Ссылка скопирована'}
              {copyState === 'error' && 'Ошибка копирования'}
            </Button>
            {canShare && (
              <Button className={styles.btn} onClick={onShare}>
                Поделиться ссылкой
              </Button>
            )}
          </div>
        </article>

        {!isMobile && (
          <article>
            <p className={styles.subhead}>или отсканируйте код</p>
            <img className={styles.img} src={dataUrl} />
            <div className={styles.btn_group}>
              <Button className={styles.btn} onClick={onDownload}>
                Сохранить код
              </Button>
            </div>
          </article>
        )}
      </div>
    </section>
  );
}
